import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MechanicCard from '../../../../components/user/maintain/mechaniccard/MechanicCard.js';
import '../../../../assets/css/user/maintainance/subscreens/mechanicfilterbycategory/MechanicFilter.css';
import AppContext from '../../../../context/AppContext.js';
import axios from 'axios';

const MechanicFilter = ({ isRentalAdmin = false }) => {  // ✅ prop yahan add karo
  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);
  const [specialization, setSpecialization] = useState([]);
  const [selectedSpecialization, setSelectedSpecialization] = useState("All");
  const [filteredMechanics, setFilteredMechanics] = useState([]);
  const [mechanic, setMechanic] = useState([]);


  const fetchAllSpecializations = () => {
    axios
      .get(`${baseUrl}/customer/specialization/fetchAllSpecializations`)
      .then((res) => {
        console.log(res.data);
        if (res.data.success == true) {
          setSpecialization(res.data.specialization);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchAllMechanics = () => {
    axios
      .get(`${baseUrl}/customer/mechanics/fetchAllMechanics`)
      .then((res) => {
        console.log(res.data);
        if (res.data.success == true) {
          setMechanic(res.data.mechanic);
          setFilteredMechanics(res.data.mechanic);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    console.log("log from the specialization  data");
    console.log("log from the mechanic  data");
    fetchAllSpecializations();
    fetchAllMechanics();
  }, []);


  // ✅ Sirf ek handleBookMechanic — isRentalAdmin check ke saath
  const handleBookMechanic = (mechanic) => {

    if (mechanic.status === 'busy') {
      alert("This mechanic is currently busy");
      return;
    }

    if (isRentalAdmin) {
      navigate(`/rental-admin/mechanic/${mechanic.id}`);
    } else {
      navigate(`/mechanic/${mechanic.id}`);
    }
  };

  // ✅ Sirf ek handleViewDetails — isRentalAdmin check ke saath
  const handleViewDetails = (mechanicId) => {
    if (isRentalAdmin) {
      navigate(`/rental-admin/mechanic/${mechanicId}`);
    } else {
      navigate(`/mechanic/${mechanicId}`);
    }
  };

useEffect(() => {
  const filtered = mechanic.filter((m) => {
    if (!selectedSpecialization || selectedSpecialization === "All") {
      return true;
    }

    return m.specialization === selectedSpecialization;
  });

  setFilteredMechanics(filtered);
}, [selectedSpecialization, mechanic]);

  return (
    <>
      <div className="mechanics-page">
        <div className="mc-container">
          <div className="mc-page-header">
            <h1 className="page-title">
              Find Your <span className="highlight-text">Mechanic Expert</span>
            </h1>
            <p className="page-subtitle">
              Browse our professional mechanics by specialization
            </p>
          </div>

          <div className="category-filter">
            <div className="filter-wrapper">

              {/* ALL BUTTON - ADD HERE */}
              <button
                className={`filter-btn ${selectedSpecialization === "All" ? "active" : ""}`}
                onClick={() => setSelectedSpecialization("All")}
              >
                All
              </button>

              {specialization.map((item, index) => (
                <button
                  key={index}
                  className={`filter-btn ${selectedSpecialization === item.specializationname ? 'active' : ''}`}
                  onClick={() => setSelectedSpecialization(item.specializationname)}
                >
                  {item.specializationname}
                </button>
              ))}

            </div>
          </div>

          <div className="results-info">
            <p className="results-count">
              Showing <strong>{filteredMechanics.length}</strong> mechanics
              {selectedSpecialization !== 'All' && (
                <span> in <strong>{selectedSpecialization}</strong></span>
              )}
            </p>
          </div>

          <div className="mechanics-grid">
            {filteredMechanics.length > 0 ? (
              filteredMechanics.map((mechanic) => (
                <div key={mechanic.id} className="mechanic-item">
                  <MechanicCard
                    mechanic={mechanic}
                    onBookClick={handleBookMechanic}
                    onViewDetails={handleViewDetails}
                  />
                </div>
              ))
            ) : (
              <div className="no-results">
                <p>No mechanics found in this category.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MechanicFilter;